export default __webpack_public_path__ + "static/4-05b618f61a6fd5e26d755e5ffacd0da8.jpeg";